export function getTerminal() {
  try {
    const terminal = window.BtDevice.externalDevices.find(o => o.type === 'PAYMENT_TERMINAL')
    console.log(`[TERMINAL] Found card terminal: ${JSON.stringify(terminal)}`)
    return terminal
  } catch (error) {
    console.warn('[TERMINAL] No payment terminal.')
    return null
  }
}

export function startPayment(terminal, amount, invoiceId) {
  console.log(`[TERMINAL] Starting payment for amount: ${amount}, document: ${invoiceId}`)

  return new Promise((resolve, reject) => {
    try {
      console.log(`[TERMINAL] Found terminal: ${JSON.stringify(terminal)}`)
      let bergSdkVersion

      try {
        bergSdkVersion = window.BtDevice.getBergSdkVersion()
        console.log(`Retrieved Berg SDK version: ${bergSdkVersion} with type: ${typeof bergSdkVersion}`)
      } catch (error) {
        console.log(`Error while retrieving Berg SDK version. Setting value to 0.`, error)
        bergSdkVersion = 0
      }

      if (bergSdkVersion >= 134) {
        const response = window.BtDevice.startPayment(
          terminal.ip,
          terminal.port,
          terminal.type,
          String(amount),
          invoiceId,
          JSON.stringify(terminal.additionalSettings)
        )
        console.log('[TERMINAL] Terminal - startPayment - Success', response)
        resolve(response)
      } else {
        const response = window.BtDevice.startPayment(terminal.ip, terminal.port, String(amount), invoiceId)
        console.log('[TERMINAL] Terminal - startPayment - Success', response)
        resolve(response)
      }
    } catch (error) {
      console.error('[TERMINAL] Terminal - startPayment - Error', error)
      reject('ERROR_PAYMENT')
    }
  })
}

export function pairTerminal(terminalType) {
  return new Promise((resolve, reject) => {
    try {
      const terminal = window.BtDevice.externalDevices.find(o => o.type === terminalType)
      const response = window.BtDevice.pairTerminal(terminal.ip, terminal.port)

      resolve(response)
    } catch (error) {
      console.error('[TERMINAL] Terminal - pairTerminal - Error: Device Error', error)
      reject('ERROR_PAIRING')
    }
  })
}

export function cancelCurrentPayment() {
  return new Promise((resolve, reject) => {
    try {
      window.BtDevice.cancelCurrentPayment()
      console.log('[TERMINAL] Terminal - cancelCurrentPayment - Success')
      resolve()
    } catch (error) {
      console.error('[TERMINAL] Terminal - cancelCurrentPayment - Error', error)
      reject('ERROR_PAYMENT')
    }
  })
}
